export default __webpack_public_path__ + "static/media/officeAndStorage.440076aa.jpeg";